<template>
  <div class="main">
      <h3 class="mb-2">Content</h3>
      <!-- Add Cost Button -->
      <b-row class="align-items-center mb-4">
          <b-col>
              <div class="d-flex justify-content-end align-items-center">
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openFacebookModal">
                      <feather-icon icon="FacebookIcon" class="text-info mr-1" size="18" /> Add Facebook</b-button>
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openInstagramModal">
                      <feather-icon icon="InstagramIcon" class="text-danger mr-1" size="18" /> Add
                      Instagram</b-button>
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openLinkedinModal">
                      <feather-icon icon="LinkedinIcon" class="text-info mr-1" size="18" /> Add LinkedIn</b-button>
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openWhatsappModal">
                      <img src="@/assets/images/logo/whatsapp.png"
                          style="width: 16px; height: 16px; margin-right:10px" />Add Whatsapp</b-button>
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openEmailModal">
                      <feather-icon icon="MailIcon" class="text-danger mr-1" size="18" /> Add Email</b-button>
                  <b-button v-if="!$route.fullPath.includes('view')" variant="primary" class="ml-1"
                      @click="openEventModal">
                      <feather-icon icon="CalendarIcon" class="text-info mr-1" size="18" /> Add Event</b-button>
              </div>

          </b-col>
      </b-row>

      <!-- No Costs Available Message -->
      <div v-if="draftId.length === 0">
          <b-row class="justify-content-center">
              <b-col md="4">
                  <b-card>
                      <b-card-body class="text-center">
                          <h2>No content available</h2>
                      </b-card-body>
                  </b-card>
              </b-col>
          </b-row>
      </div>
<!-- Search Input -->
<b-row class="mb-4 align-items-center">
  <b-col md="4">
    <b-form-input
      v-model="searchQuery"
      placeholder="Search content..."
      :debounce="300"
    />
  </b-col>
  <b-col md="8" class="text-right">
    <span class="text-muted">
      Showing {{ filteredCost.length }} of {{ draftId.length }} contents
    </span>
  </b-col>
</b-row>

      <!-- Costs Table View -->
      <div>
          <b-table striped hover responsive :items="paginatedCost" :fields="fields">
              <template #cell(createdOn)="data">
                  {{ formatDate(data.item.createdOn) }}
              </template>
              <template #cell(publishedDate)="data">
                  {{ formatDate(data.item.publishedDate) }}
              </template>
              <template #cell(actions)="data">
                  <b-dropdown v-if="!$route.fullPath.includes('view')" id="actions-dropdown" variant="link" size="sm"
                      text="Actions" right no-caret>
                      <template #button-content>
                          <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                      </template>
                      <b-dropdown-item v-if="data.item.status !== 'PUBLISHED'" @click="openEditModal(data.item)">
                          <feather-icon icon="EditIcon" size="16" class="mr-50" />
                          Edit
                      </b-dropdown-item>
                      <b-dropdown-item v-if="data.item.status == 'PUBLISHED'" @click="viewContent(data.item)">
                        <feather-icon icon="EyeIcon" size="16" class="mr-50" />
                        View
                    </b-dropdown-item>
                      <b-dropdown-item @click="openCostModal(data.item)">
                          <feather-icon icon="ListIcon" size="16" class="mr-50" />
                          Add Costs
                      </b-dropdown-item>
                      <b-dropdown-item @click="openTaskModal(data.item)">
                          <feather-icon icon="ListIcon" size="16" class="mr-50" />
                          Add Tasks
                      </b-dropdown-item>
                      <b-dropdown-item @click="openKpiModal(data.item)">
                          <feather-icon icon="BarChart2Icon" size="16" class="mr-50" />
                          KPI's
                      </b-dropdown-item>
                      <b-dropdown-item 
      v-if="data.item.platform !== 'Event' && data.item.status !== 'PUBLISHED'"
      @click="postNow(data.item)">
      <feather-icon icon="SendIcon" size="16" class="mr-50" />
      Post Now
    </b-dropdown-item>
                      <b-dropdown-item v-if="data.item.status !== 'PUBLISHED'" @click="deleteCost(data.item.campaignContentsId)">
                          <feather-icon icon="TrashIcon" size="16" class="mr-50" />
                          Delete
                      </b-dropdown-item>
                  </b-dropdown>
              </template>
          </b-table>

          <email-modal ref="emailModal" @content-updated="refreshCostTable" />
          <facebook-modal ref="facebookModal" @content-updated="refreshCostTable" />
          <instagram-modal ref="instagramModal" @content-updated="refreshCostTable" />
          <linkedIn-modal ref="linkedinModal" @content-updated="refreshCostTable" />
          <whatsapp-modal ref="whatsappModal" @content-updated="refreshCostTable" />
          <event-modal ref="eventModal" @content-updated="refreshCostTable" />

          <b-modal id="modal-cost" ref="costModal" title="Add Cost" hide-footer centered>
            <validation-observer ref="cost">
  <b-form @submit.prevent="addCost">
    <b-row>
      <b-col md="12">
        <b-form-group label="Name" label-for="category">
            <validation-provider rules="required" v-slot="{ errors }" name="Name" vid="Name">
          <b-form-input id="category" placeholder="Name" v-model="newCost.category" />
          <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Description" label-for="description">
            <validation-provider rules="required" v-slot="{ errors }" name="Description" vid="Description">
          <b-form-input id="description" placeholder="Description" v-model="newCost.description" />
          <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Amount" label-for="amount">
            <validation-provider rules="required" v-slot="{ errors }" name="Amount" vid="Amount">
          <b-form-input id="amount" type="number" placeholder="Amount" v-model="newCost.amount"/>
          <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Date" label-for="date">
            <validation-provider rules="required" v-slot="{ errors }" name="Date" vid="Date">
          <b-form-datepicker id="date" v-model="newCost.date"  />
          <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12" class="d-flex justify-content-end">
        <b-button type="submit" variant="primary">Save Cost</b-button>
      </b-col>
    </b-row>
  </b-form>
</validation-observer>
</b-modal>


<b-modal id="modal-task" ref="taskModal" title="Add Task" hide-footer @hide="resetForm" size="lg" centered>
    <validation-observer ref="taskForm">
        <b-form @submit.prevent="validateAndSubmit">
            <b-row>
                <!-- Task Title -->
                <b-col md="12">
                    <b-form-group label="Title" label-for="task_title">
                        <validation-provider rules="required" v-slot="{ errors }" name="Title">
                            <b-form-input id="task_title" placeholder="Title" v-model="newTask.title" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Task Description -->
                <b-col md="12">
                    <b-form-group label="Description" label-for="task_description">
                        <validation-provider rules="required" v-slot="{ errors }" name="Description">
                            <b-form-input id="task_description" placeholder="Description" v-model="newTask.description" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Start Date -->
                <b-col md="6">
                    <b-form-group label="Start Date" label-for="start_date">
                        <validation-provider rules="required" v-slot="{ errors }" name="Start Date">
                            <b-form-datepicker id="start_date" v-model="newTask.startDate"
                                :min="currentDate" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- End Date -->
                <b-col md="6">
                    <b-form-group label="End Date" label-for="end_date">
                        <validation-provider rules="required" v-slot="{ errors }" name="End Date">
                            <b-form-datepicker id="end_date" v-model="newTask.endDate"
                                :min="newTask.startDate || currentDate" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Assignee -->
                <b-col md="6">
                    <b-form-group label="Assignee(s)" label-for="assignee">
                        <validation-provider rules="required" v-slot="{ errors }" name="Assignee">
                            <b-form-select id="assignee" v-model="newTask.assigneeId" :options="assigneeOptions" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Status -->
                <b-col md="6">
                    <b-form-group label="Status" label-for="status">
                        <validation-provider rules="required" v-slot="{ errors }" name="Status">
                            <b-form-select v-model="newTask.status" :options="statusOptions" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Submit Button -->
                <b-col md="12" class="d-flex justify-content-end">
                    <b-button type="submit" variant="primary">Add Task</b-button>
                </b-col>
            </b-row>
        </b-form>
    </validation-observer>
</b-modal>

          <b-modal id="modal-kpi" ref="kpiModal" title="KPI'S" hide-footer centered>
              <b-form @submit.prevent="saveKpi">
                  <b-row>
                      <b-col md="12">
                          <b-form-group label="KPI Name" label-for="name1">
                              <b-form-input id="name1" placeholder="KPI Name" v-model="kpi.name1" required />
                          </b-form-group>
                      </b-col>
                      <b-col md="12">
                          <b-form-group label="KPI Target" label-for="target1">
                              <b-form-input id="target1" placeholder="KPI Target" v-model="kpi.target1" required />
                          </b-form-group>
                      </b-col>
                      <b-col md="12">
                          <b-form-group label="KPI Value" label-for="value1">
                              <b-form-input id="value1" placeholder="KPI Value" v-model="kpi.value1" required />
                          </b-form-group>
                      </b-col>

                      <b-col md="12" class="d-flex justify-content-end">
                          <b-button type="submit" variant="primary">Save</b-button>
                      </b-col>
                  </b-row>
              </b-form>
          </b-modal>

          <b-modal id="modal-edit-post" ref="editPostModal" title="Edit Post" hide-footer centered>
            <validation-observer ref="editPostForm">
              <b-form @submit.prevent="updatePost">
                <b-row>
                  <!-- Post Name -->
                  <b-col md="12">
                    <b-form-group label="Post Name" label-for="editPostName">
                      <validation-provider rules="required" v-slot="{ errors }" name="Post Name">
                        <b-form-input id="editPostName" placeholder="Enter Post Name" v-model="editPostData.postName" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
          
                  <!-- Budget -->
                  <b-col md="12">
                    <b-form-group label="Budget" label-for="editBudget">
                      <validation-provider rules="required|numeric" v-slot="{ errors }" name="Budget">
                        <b-form-input id="editBudget" type="number" placeholder="Enter Budget" v-model="editPostData.budget" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
          
                  <!-- Quill Editor for Content -->
                  <b-col md="12" v-if="editPostData.platform !== 'WhatsApp'">
                    <b-form-group label="Content" label-for="editContent">
                      <validation-provider rules="required" v-slot="{ errors }" name="Content">
                        <quill-editor v-model="editPostData.content" :options="quillOptions" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
          <!-- Status Dropdown -->
        <b-col md="12">
            <b-form-group label="Status" label-for="editStatus">
              <validation-provider rules="required" v-slot="{ errors }" name="Status">
                <b-form-select id="editStatus" v-model="editPostData.status" :options="statusEditOptions" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
  
                  <!-- Save Button -->
                  <b-col md="12" class="d-flex justify-content-end">
                    <b-button type="submit" variant="primary">Save Changes</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
          


          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="draftId.length" align="center"
              class="my-2" />
      </div>

  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BCard,
  BCardBody,
  BTable,
  BDropdown,
  BDropdownItem,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormSelect,
  BPagination
} from "bootstrap-vue";
import EmailModal from "./EmailModal.vue";
import FacebookModal from "./FacebookModal.vue";
import InstagramModal from "./InstagramModal.vue";
import LinkedInModal from "./LinkedinModal.vue";
import EventModal from "./EventModal.vue";
import WhatsappModal from "./WhatsappModal.vue";
import Swal from 'sweetalert2';
import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver} from "vee-validate";
export default {
  components: {
      BRow,
      BCol,
      BButton,
      BCard,
      BCardBody,
      BTable,
      BDropdown,
      BDropdownItem,
      BModal,
      BForm,
      BFormGroup,
      BFormInput,
      BFormDatepicker,
      BFormSelect,
      BPagination,
      EmailModal,
      FacebookModal,
      InstagramModal,
      LinkedInModal,
      EventModal,
      WhatsappModal,
      ValidationProvider,
      ValidationObserver,
      quillEditor
  },
  data() {
      return {
          id: this.$route.params.id,
          selectedCampaignContentId: null,
          costs: [], // All costs
          currentPage: 1, // Active page
          perPage: 5, // Number of items per page
          searchQuery: "",  // Store user input
          fields: this.getFields(),
          editPostData: {
      campaignContentsId: null,
      postName: "",
      budget: 0,
      content: "",
      status: null
    },
    quillOptions: {
                theme: "snow", // Use 'snow' theme for basic styling
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"], // Formatting buttons
                        [{ list: "ordered" }, { list: "bullet" }], // List buttons
                        [{ align: [] }], // Alignment buttons
                        ["clean"], // Remove formatting button
                    ],
                },
            },
    statusEditOptions: [
      { value: "DRAFT", text: "Draft" },
      { value: "SCHEDULED", text: "Scheduled" },
      { value: "CANCELLED", text: "Cancelled" },
    ],
          newCost: {
            //   id: null,
              category: "",
              description: "",
              amount: null,
              date: null,
          },
          currentDate: new Date().toISOString().split("T")[0],
          categoryOptions: ["Transport", "Office Supplies", "Utilities", "Others"],
          task: {
              name: "",
              status: "Not Started",
              description: "",
          },
          newTask: {
              title: "",
              description: "",
              startDate: "",
              endDate: "",
              assigneeId: "",
              status: "NOTSTARTED",
          },
          statusOptions: [
              { value: "NOTSTARTED", text: "Not Started" },
              { value: "INPROGRESS", text: "In Progress" },
              { value: "ONHOLD", text: "On Hold" },
              { value: "COMPLETED", text: "Completed" },
          ],
          assigneeOptions: [],
          currentDate: new Date().toISOString().split("T")[0],
          kpi: {
              target1: "",
              name1: "",
              value1: "",

          },
          campaignList: "",
          titleState: null,
          descriptionState: null,
          startDateState: null,
          endDateState: null,
          assigneeState: null,
          statusState: null,
          isEditing: false,
          editingTaskId: null,
      };
  },
  async mounted() {

      await this.getCampaignContentsByCampaignIdAction(this.id)
          .then(() => {
              this.totalRows = this.draftId.length;
          })
          .catch((response) => {
              console.log(response);
          })
      await this.fetchAssignees();
  },
  methods: {
    openEditModal(dataItem) {
    this.editPostData = {
      campaignContentsId: dataItem.campaignContentsId,
      postName: dataItem.name,
      budget: dataItem.budget || 0,
      content: dataItem.platform === "WhatsApp" ? "" : dataItem.content || "",
      status: dataItem.status || "DRAFT", // Default status
      platform: dataItem.platform,
    };
    this.$bvModal.show("modal-edit-post");
  },
  viewContent(dataItem) {
    if (dataItem.contentPostLink) {
        window.open(dataItem.contentPostLink, "_blank");
    } else {
        this.$swal({
            title: "No Link Available",
            text: "The post link is not available for this content.",
            icon: "warning",
        });
    }
},
  async updatePost() {
    this.$refs.editPostForm.validate().then(async (success) => {
      if (success) {
        let loader = this.$swal({
          title: "Updating Post...",
          text: "Please wait while the post is being updated.",
          didOpen: () => this.$swal.showLoading(),
          allowOutsideClick: () => !this.$swal.isLoading(),
        });

        try {
          const updatedData = {
            id: this.editPostData.campaignContentsId, 
            campaignId: this.id,
            name: this.editPostData.postName,
            budget: String(this.editPostData.budget),
            content: this.editPostData.content,
            status: this.editPostData.status,
            platform: this.editPostData.platform

          };

          // Call Vuex action or API
          await this.putCampaignDraftAction(updatedData);

          loader.close();
          this.$swal({
            title: "Success!",
            text: "Post updated successfully.",
            icon: "success",
          });

          this.$bvModal.hide("modal-edit-post");
          this.refreshCostTable();
        } catch (error) {
          console.error("Error updating post:", error);
          this.$swal({
            title: "Error!",
            text: "Something went wrong while updating the post.",
            icon: "error",
          });
        }
      }
    });
  },

    editCost(dataItem) {
        this.selectedCampaignContentId = dataItem.campaignContentsId;

        switch (dataItem.platform) {
            case "Facebook":
                this.$refs.facebookModal.setFormData(dataItem);
                this.$refs.facebookModal.$bvModal.show("modal-facebook");
                break;
            case "Instagram":
                this.$refs.instagramModal.setFormData(dataItem);
                this.$refs.instagramModal.$bvModal.show("modal-instagram");
                break;
            case "LinkedIn":
                this.$refs.linkedinModal.setFormData(dataItem);
                this.$refs.linkedinModal.$bvModal.show("modal-linkedin");
                break;
            case "WhatsApp":
                this.$refs.whatsappModal.setFormData(dataItem);
                this.$refs.whatsappModal.$bvModal.show("modal-whatsapp");
                break;
            case "Email":
                this.$refs.emailModal.setFormData(dataItem);
                this.$refs.emailModal.$bvModal.show("modal-email");
                break;
            case "Event":
                this.$refs.eventModal.setFormData(dataItem);
                this.$refs.eventModal.$bvModal.show("modal-event");
                break;
            default:
                console.warn("Unknown platform:", dataItem.platform);
        }
    },
    openCostModal(costData) {
          this.selectedCampaignContentId = costData.campaignContentsId;
          this.newCost = {
            category: costData.category || "",
            description: costData.description || "",
            amount: costData.amount || "",
            date: costData.date || "",
          };
          this.$bvModal.show("modal-cost");
      },
      async deleteCost(campaignContentsId) {
            try {
                const confirmDelete = await this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    didOpen: () => {
                  document.querySelector(".swal2-actions").style.display = "flex";
                  document.querySelector(".swal2-actions").style.justifyContent = "center";
                  document.querySelector(".swal2-actions").style.gap = "20px";
              },
                });

                if (confirmDelete.isConfirmed) {
                    let loader = this.$swal({
                        title: "Processing...",
                        text: "Please wait while the content is being deleted",
                        didOpen: () => {
                            this.$swal.showLoading();
                        },
                        allowOutsideClick: () => !this.$swal.isLoading(),
                        buttonsStyling: false,
                        showConfirmButton: false,
                    });

                    // Call Vuex action to delete content by campaignContentsId
                    await this.deleteCampaignDraftAction(campaignContentsId);

                    loader.close();

                    this.$swal({
                        title: "Deleted!",
                        text: "Content has been deleted successfully.",
                        icon: "success",
                        confirmButtonText: "OK",
                    });

                    // Refresh content table after deletion
                    this.refreshCostTable();
                }

            } catch (error) {
                console.error("Error deleting content:", error);
                this.$swal({
                    title: "Error",
                    text: "Failed to delete content. Cross Check Status and Please try again.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        },
      ...mapActions("marketingModule", [
          "getCampaignDraftListAction",
          "postCampaignDraftAction",
          "putCampaignDraftAction",
          "getCampaignDraftByIDAction",
          "deleteCampaignDraftAction",
          "getMarketingCampaignByIdAction",
          "getCampaignContentsByCampaignIdAction",
          "postSocialAction",
          "postKPIAction",
          "putKPIAction"
      ]),
      ...mapActions("marketingModule", [
          "postTaskAction",
          "getAssigneeListAction"

      ]),
      ...mapActions("marketingModule", [
        "getCostListAction",
        "postCostAction",
      ]),
      async fetchAssignees() {
          try {
              const response = await this.getAssigneeListAction();

              if (Array.isArray(response)) {
                  this.assigneeOptions = response.map(assignee => ({
                      value: assignee.id,
                      text: `${assignee.firstName} ${assignee.lastName}`,
                  }));
              } else {
                  console.warn("Unexpected response format:", response);
                  this.assigneeOptions = [];
              }
          } catch (error) {
              console.error("Error fetching assignees:", error);
              this.assigneeOptions = [];
          }
      },

      async addTask() {
          const selectedStatus = this.newTask.status;
          const selectedAssignee = this.assigneeOptions.find(option => option.value === this.newTask.assigneeId);
          const assigneeName = selectedAssignee ? selectedAssignee.text : '';
          const taskData = {
              campaignId: this.id,
              title: this.newTask.title,
              description: this.newTask.description,
              startDate: this.newTask.startDate,
              endDate: this.newTask.endDate,
              assignee: this.newTask.assigneeId,
              campaignContentsId: this.selectedCampaignContentId,  // Link to campaign content
              status: selectedStatus,
              assigneeName: assigneeName,
          };
          console.log("Task Data:", taskData);

          try {
              let loader = this.$swal({
                  title: "Adding Task...",
                  text: "Please wait while the task is being added.",
                  didOpen: () => this.$swal.showLoading(),
                  allowOutsideClick: () => !this.$swal.isLoading(),
              });

              const response = await this.postTaskAction(taskData);
              loader.close();

              if (response && response.success) {
                  this.$swal({
                      title: "Success!",
                      text: "Task added successfully. The page will now refresh.",
                      icon: "success",
                      timer: 2000,  // Delay before refreshing
                      showConfirmButton: false,
                  }).then(() => {
                      window.location.reload();  // Refresh the entire page
                  });

                  // Close the modal after successful submission
                  this.$refs.taskModal.hide();

                  this.resetForm();
              } else {
                  throw new Error("Failed to add task.");
              }
          } catch (error) {
              console.error("Error adding task:", error);
              this.$swal({
                  title: "Error!",
                  text: "Something went wrong while adding the task.",
                  icon: "error",
              });
          }
      },

      async addCost() {
    this.$refs.cost.validate().then(async (success) => {
        if (success) {
            const costData = {
                campaignId: this.id,
                campaignContentsId: this.selectedCampaignContentId, 
                category: this.newCost.category,
                description: this.newCost.description,
                amount: this.newCost.amount,
                date: this.newCost.date,
            };

            let loader = this.$swal({
                    title: "Adding Cost...",
                    text: "Please wait while the cost is being added.",
                    didOpen: () => this.$swal.showLoading(),
                    allowOutsideClick: () => !this.$swal.isLoading(),
                });

            
            try {

                // Ensure postCostAction is awaited
                const response = await this.postCostAction(costData);
                
                // Close the loader once the response is received
                this.$swal.close();
                if (response && response.success) {
                    await this.$swal({
                        title: "Success!",
                        text: "Cost added successfully. The page will now refresh.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });

                    window.location.reload();  // Refresh the page after success

                    // Close modal after successful submission
                    this.$refs.costModal.hide();

                    this.resetForm();
                } else {
                    throw new Error("Failed to add cost.");
                }
            } catch (error) {
                console.error("Error adding cost:", error);

                // Close the loading Swal if there's an error
                if (loader) this.$swal.close();

                this.$swal({
                    title: "Error!",
                    text: "Something went wrong while adding the cost.",
                    icon: "error",
                });
            }
        }
    });
},

async validateAndSubmit() {
        // Ensure all fields are validated
        const valid = await this.$refs.taskForm.validate();
        
        if (valid) {
            this.addTask(); // Call the method to submit task
        } else {
            this.$swal({
                title: "Validation Error",
                text: "Please fill in all required fields.",
                icon: "error",
            });
        }
    }
      ,

      validateTitle() {
          this.titleState = this.newTask.title.trim() !== "" ? true : false;
      },
      validateDescription() {
          this.descriptionState = this.newTask.description.trim() !== "" ? true : false;
      },
      validateStartDate() {
          this.startDateState = this.newTask.startDate ? true : false;
      },
      validateEndDate() {
          this.endDateState = this.newTask.endDate >= this.newTask.startDate ? true : false;
      },
      validateAssignee() {
          this.assigneeState = this.newTask.assigneeId ? true : false;
      },
      validateStatus() {
          this.statusState = this.newTask.status ? true : false;
      },
      resetForm() {
          this.newTask = {
              title: "",
              description: "",
              startDate: "",
              endDate: "",
              assigneeId: "",
              status: "NOTSTARTED",
          };
          this.isEditing = false;
      },
      formatDate(dateString) {
          if (!dateString) return '-';
          const date = new Date(dateString);
          return date.toLocaleString('en-US', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: true
          });
      },
      openEmailModal(item = null) {
          if (item) {
              // this.$refs.emailModal.setFormData(item);
          }
          this.$refs.emailModal.$bvModal.show("modal-campaign");
      },
      openFacebookModal(item = null) {
          if (item) {
              this.$refs.facebookModal.setFormData(item);
          } else {
              this.$refs.facebookModal.setFormData({
                  campaignName: "",
                  cost: "",
                  content: "",
                  link: "",
                  mediaType: "image",
                  scheduleDate: null
              });
          }
          this.$refs.facebookModal.$bvModal.show("modal-facebook");
      },
      openInstagramModal(item = null) {
          if (item) {
              this.$refs.instagramModal.setFormData(item);
          } else {
              this.$refs.instagramModal.setFormData({
                  campaignName: "",
                  cost: "",
                  content: "",
                  link: "",
                  mediaType: "image",
                  scheduleDate: null
              });
          }
          this.$refs.instagramModal.$bvModal.show("modal-instagram");
      },
      openLinkedinModal(item = null) {
          if (this.$refs.linkedinModal) {
              if (item) {
                  this.$refs.linkedinModal.setFormData(item);
              } else {
                  this.$refs.linkedinModal.setFormData({
                      campaignName: "",
                      cost: "",
                      content: "",
                      link: "",
                      mediaType: "image",
                      scheduleDate: null
                  });
              }
              this.$refs.linkedinModal.$bvModal.show("modal-linkedin");
          } else {
              console.error("LinkedIn modal reference is not available.");
          }
      }, openEventModal(item = null) {
          if (item) {
              // this.$refs.eventModal.setFormData(item);
          }
          this.$refs.eventModal.$bvModal.show("modal-event");
      },
      openWhatsappModal(item = null) {
          if (this.$refs.whatsappModal) {
              if (item) {
                  this.$refs.whatsappModal.setFormData(item);
              } else {
                  this.$refs.whatsappModal.setFormData({
                      campaignName: "",
                      cost: "",
                      content: "",
                      link: "",
                      mediaType: "image",
                      scheduleDate: null
                  });
              }
              this.$refs.whatsappModal.$bvModal.show("modal-whatsapp");
          } else {
              console.error("WhatsApp modal reference is not available.");
          }
      },
      
      getFields() {
    const baseFields = [
        { key: "name", label: "Content Name", sortable: true },
        { key: "platform", label: "Platform", sortable: true },
        { key: "createdOn", label: "Created Date", sortable: true },
        { key: "budget", label: "Budget", sortable: true },
        { key: "totalCosts", label: "Total Costs", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "publishedDate", label: "Published Date", sortable: true },
        { key: "totalTasksCompleted", label: "Total Tasks", sortable: true }
    ];

    // Check if 'view' exists in the URL
    if (!this.$route.fullPath.includes("view")) {
        baseFields.push({ key: "actions", label: "Actions" });
    }

    return baseFields;
},

      open(taskData) {
          this.task = taskData || { name: "", status: "Not Started", description: "" };
          this.$bvModal.show("modal-task");
      },
      openTaskModal(taskData) {
          this.selectedCampaignContentId = taskData.campaignContentsId;
          this.newTask = {
              title: taskData.title || "",
              description: taskData.description || "",
              startDate: taskData.startDate || "",
              endDate: taskData.endDate || "",
              assigneeId: taskData.assigneeId || "",
              status: taskData.status || "NOTSTARTED",
          };
          this.$bvModal.show("modal-task");
      },
      saveTask() {
          this.$bvModal.hide("modal-task"); // Close modal
      },

      open(costData) {
          this.cost = costData;
          this.$bvModal.show("modal-cost");
      },
      
      openKpiModal(kpiData) {
          this.selectedCampaignContentId = kpiData.campaignContentsId;
          if (kpiData && kpiData.kpIs && kpiData.kpIs.length > 0) {
              // Mapping KPI values from response
              this.kpi = {
                  name1: kpiData.kpIs[0].metricName || "",
                  target1: kpiData.kpIs[0].metricType || "",
                  value1: kpiData.kpIs[0].metricValue || ""
              };
          } else {
              // If no KPI data available, keep the form empty
              this.kpi = {
                  name1: "",
                  target1: "",
                  value1: ""
              };
          }
          // Open the KPI modal
          this.$bvModal.show("modal-kpi");
      },
      async saveKpi() {
          try {
              let payload = {};
              const selectedCampaign = this.draftId.find(
                  item => item.campaignContentsId === this.selectedCampaignContentId
              );

              console.log("Selected Campaign:", selectedCampaign);

              let loader = this.$swal({
                  title: "Processing...",
                  text: "Please wait while saving KPI...",
                  didOpen: () => {
                      this.$swal.showLoading();
                  },
                  allowOutsideClick: () => !this.$swal.isLoading(),
                  buttonsStyling: false,
                  showConfirmButton: false,
              });

              // Extract KPI ID if it exists
              const kpiData = selectedCampaign?.kpIs?.[0];
              const kpiId = kpiData?.id || null;

              if (kpiId) {
                  // Update existing KPI
                  payload = {
                      id: kpiId,  // Assign correct KPI ID
                      campaignContentsId: this.selectedCampaignContentId,
                      metricType: this.kpi.target1,
                      metricName: this.kpi.name1,
                      metricValue: this.kpi.value1,
                      isActive: true,
                  };
                  console.log("Payload to update KPI:", payload);

                  await this.putKPIAction(payload);
                  this.$swal({
                      title: "Success",
                      text: "KPI updated successfully!",
                      icon: "success",
                  });
              } else {
                  // No KPI exists, create a new KPI
                  payload = {
                      campaignContentsId: this.selectedCampaignContentId,
                      metricType: this.kpi.target1,
                      metricName: this.kpi.name1,
                      metricValue: this.kpi.value1,
                      isActive: true,
                  };
                  console.log("Payload to post KPI:", payload);

                  await this.postKPIAction(payload);
                  this.$swal({
                      title: "Success",
                      text: "KPI created successfully!",
                      icon: "success",
                  });
              }

              // Close modal and refresh data
              this.$bvModal.hide("modal-kpi");
              this.refreshCostTable();
          } catch (error) {
              console.error("Error saving KPI:", error);
              this.$swal({
                  title: "Error",
                  text: "Failed to save KPI. Please try again.",
                  icon: "error",
              });
          } finally {
          }
      }
      ,
      async postNow(dataItem) {
          let loader = this.$swal({
              title: "Processing...",
              text: "Please wait while the content is being posted",
              didOpen: () => {
                  this.$swal.showLoading();
              },
              allowOutsideClick: () => !this.$swal.isLoading(),
              buttonsStyling: false,
              showConfirmButton: false,
          });

          const payload = {
              ContentId: dataItem.campaignContentsId,
              scheduleUnixTimeStamp: "",
              token: "",
              platform: dataItem.platform,
          };

          console.log("Payload to post:", payload);

          try {
              const response = await this.postSocialAction(payload);
              console.log("Response from postSocialAction:", response);

              let postUrl = '';
              // Determine the URL based on the platform
              switch (dataItem.platform) {
                  case 'Facebook':
                      postUrl = response.data.result.facebook;
                      break;
                  case 'Instagram':
                      postUrl = response.data.result.instagram;
                      break;
                  case 'LinkedIn':
                      postUrl = response.data.result.linkedIn;
                      break;
                  case 'WhatsApp':
                      postUrl = response.data.result.WhatsApp;
                      break;
                  case 'Email':
                      postUrl = response.data.result.Email;
                      break;
                  case 'Event':
                      postUrl = response.data.result.Event;
                      break;
                  default:
                      postUrl = '';
              }

              console.log("Post URL:", postUrl);

              if (postUrl) {
                  this.success("Post added successfully!", postUrl);
              } else {
                  console.error("Post URL is missing in the response.");
                  this.error("Post added, but no URL to view the post.");
              }
              loader.close();
              this.refreshCostTable();
          } catch (error) {
              console.error("Error adding post:", error);
              loader.close();
              this.error("Failed to add post. Please try again.");
          }
      },

      success(message, postUrl) {
          this.$swal({
              title: "Marketing Campaign Added!",
              text: `${message} Click "Go" to view it.`,
              icon: "success",
              customClass: {
                  confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
              showCancelButton: false,
              confirmButtonText: "Go",
              confirmButtonColor: "#007bff",
              showCloseButton: true,
          }).then((result) => {
              if (result.isConfirmed) {
                  window.open(postUrl, '_blank');
              }
          });
      },

      async fetchCampaignList() {
          try {
              const response = await this.getCampaignContentsByCampaignIdAction(this.$route.params.id);
              console.log('this.$route.params.id', this.$route.params.id);
              this.campaignList = response; // Save the response to campaignList
              console.log('Campaign List:', this.campaignList); // Debug log
          } catch (error) {
              console.error('Error fetching campaign list:', error);
          }
      },
      async refreshCostTable() {
          try {
              await this.getCampaignContentsByCampaignIdAction(this.id);
              this.totalRows = this.draftId.length;
          } catch (error) {
              console.error("Error refreshing content table:", error);
          }
      },

  },
  computed: {
      ...mapGetters("marketingModule", ["draftId", "campaignId", "loading"]),
      filteredCost() {
    if (!this.searchQuery) {
      return this.draftId; // If no search query, return full list
    }

    const query = this.searchQuery.toLowerCase();

    return this.draftId.filter(item =>
      (item.name && item.name.toLowerCase().includes(query)) ||
      (item.platform && item.platform.toLowerCase().includes(query)) ||
      (item.status && item.status.toLowerCase().includes(query))
    );
  },

  paginatedCost() {
    const sortedDrafts = [...this.filteredCost].sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
    const start = (this.currentPage - 1) * this.perPage;
    const end = start + this.perPage;
    return sortedDrafts.slice(start, end);
  }
  }
};
</script>

<style>
.swal-actions-spacing {
    display: flex;
    justify-content: center;
    /* Align buttons in the center */
    gap: 15px;
    /* Adjust space between buttons */
  }
  
  /* Optional: Adjust individual button margins */
  .swal-confirm-btn {
    padding: 8px 16px;
  }
  
  .swal-cancel-btn {
    padding: 8px 16px;
  }
</style>